import * as THREE from 'three';

export abstract class PuzzleElement {
  protected mesh: THREE.Mesh | THREE.Group;
  protected isActive: boolean = false;
  protected position: THREE.Vector3;
  
  constructor(position: THREE.Vector3) {
    this.position = position.clone();
    this.mesh = this.createMesh();
    this.mesh.position.copy(position);
  }
  
  protected abstract createMesh(): THREE.Mesh | THREE.Group;
  public abstract update(deltaTime: number, playerPosition: THREE.Vector3): void;
  
  public getMesh(): THREE.Mesh | THREE.Group {
    return this.mesh;
  }
  
  public getPosition(): THREE.Vector3 {
    return this.position.clone();
  }
  
  public isActiveState(): boolean {
    return this.isActive;
  }
  
  public getBoundingBox(): THREE.Box3 {
    return new THREE.Box3().setFromObject(this.mesh);
  }
}
